import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { SkillBadge } from "@/components/ui/skill-badge"
import { ArrowRight } from "lucide-react"

export function CareerSpotlight() {
  const skills = ["HTML", "CSS", "JavaScript", "React", "Problem Solving"]

  return (
    <Card className="border-slate-200 shadow-sm sticky top-10">
      <CardContent className="p-6 text-center">
        <div className="w-32 h-32 rounded-full mx-auto border-4 border-white bg-slate-200 mt-4 flex items-center justify-center">
          <span className="text-4xl font-bold text-slate-400">👤</span>
        </div>

        <h3 className="text-lg font-bold text-slate-900 mt-4">Career Spotlight</h3>
        <p className="text-2xl font-bold text-indigo-600 mt-1">Web Developer</p>

        <div className="mt-6 text-left">
          <p className="font-semibold text-slate-900 mb-2">Key Skills & Stacks:</p>
          <div className="flex flex-wrap gap-2 justify-center">
            {skills.map((skill) => (
              <SkillBadge key={skill} skill={skill} />
            ))}
          </div>
        </div>

        <Button className="w-full mt-8 bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2">
          <span>Explore Web Developer Path</span>
          <ArrowRight className="w-4 h-4" />
        </Button>
      </CardContent>
    </Card>
  )
}
